<script>
export default {
  name: "YearsMixin",
  data() {
    return {
      years: [
        { date: "896" },
        { date: "955" },
        { date: "1001" },
        { date: "1092" },
        { date: "1102" },
        { date: "1222" },
        { date: "1241" },
        { date: "1308" },
        { date: "1389" },
        { date: "1434" },
        { date: "1456" },
        { date: "1526" },
        { date: "1540" },
        { date: "1566" },
        { date: "1575" },
        { date: "1648" },
        { date: "1701" },
        { date: "1740" },
        { date: "1780" },
        { date: "1787" },
        { date: "1815" },
        { date: "1848" },
        { date: "1867" },
        { date: "1879" },
        { date: "1913" },
        { date: "1914" },
        { date: "1919" },
        { date: "1920" },
        { date: "1939" },
        { date: "1945" },
        { date: "1956" },
        { date: "1988" },
        { date: "1989" },
        { date: "2004" }
      ],
      yearsColorCodes: [
        "#0A8AC0",
        "#1624D3",
        "#6A0499",
        "#F7E941",
        "#088366",
        "#EA1B2A",
        "#31AF4C",
        "#FF5CAE"
      ]
    };
  }
};
</script>